import { useState } from 'react';
import Hero from './components/Hero';
import Introduction from './components/Introduction';
import ThreeReasons from './components/ThreeReasons';
import Services from './components/Services';
import SubsidyIntroduction from './components/SubsidyIntroduction';
import PricingPlans from './components/PricingPlans';
import Testimonials from './components/Testimonials';
import Comparison from './components/Comparison';
import SupportFlow from './components/SupportFlow';
import FAQ from './components/FAQ';
import About from './components/About';
import FinalCTA from './components/FinalCTA';
import Header from './components/Header';
import Footer from './components/Footer';

export default function Home() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Header isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
      <Hero />
      <Introduction />
      <ThreeReasons />
      <Services />
      <SubsidyIntroduction />
      <PricingPlans />
      <Comparison />
      <Testimonials />
      <SupportFlow />
      <FAQ />
      <About />
      <FinalCTA />
      <Footer />
    </div>
  );
}
